import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Configuración de Firebase para GreenScape
// NOTA: estos valores vienen de la consola de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB0Z36Tw_Auiv7Oy9OPSHwNupTJOij1rlc",
  authDomain: "greenscape-room-2yl-game.firebaseapp.com",
  databaseURL: "https://greenscape-room-2yl-game-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "greenscape-room-2yl-game",
  storageBucket: "greenscape-room-2yl-game.firebasestorage.app",
  messagingSenderId: "992714517108",
  appId: "1:992714517108:web:920bbf46b23f9d5b773f21",
  measurementId: "G-GFM69K5QEL"
};

// Inicializar Firebase app (solo una vez)
const app = initializeApp(firebaseConfig);

// Exportar instancia de Realtime Database
const db = getDatabase(app);

export { app, db };

